import { render } from "./updatevendor.vue?vue&type=template&id=d9b6889c"
import script from "./updatevendor.vue?vue&type=script&lang=js"
export * from "./updatevendor.vue?vue&type=script&lang=js"

import "./updatevendor.vue?vue&type=style&index=0&id=d9b6889c&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__